import { Component, inject, Input, Output, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EventEmitter } from '@angular/core';

import { AddressService } from '@services/address.service';
import { SnackbarService } from '@services/snackbar.service';

import { DialogComponent } from '../dialog/dialog.component';
import { AddressAddComponent } from 'src/app/profile/addresses/address-add/address-add.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-address-card',
  templateUrl: './address-card.component.html',
  styleUrls: ['./address-card.component.scss'],
  standalone: true,
  imports: [MatCardModule, MatIconModule, MatFormFieldModule]
})
export class AddressCardComponent {

  @Input() data: any;
  @Input() currentAddressId: number;
  @Output() reload = new EventEmitter();
  @Output() favorite = new EventEmitter();

  private plaformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.plaformId);

  constructor(
    private dialog: MatDialog,
    private addressService: AddressService,
    private snackbarService: SnackbarService,
  ) { }

  public onEdit(): void {
    this.dialog.open(AddressAddComponent, {
      width: '500px',
      panelClass: 'as-address-add-modal',
      disableClose: true,
      data: { edit: true, ...this.data }
    }).afterClosed().subscribe(response => {
      if (response.data) {
        this.reload.emit();
        this.snackbarService.openSnackbar('ADDRESSES.updated', 'success');
      }
    });
  }

  public onDelete(): void {
    this.dialog.open(DialogComponent, {
      data: {
        address: {
          tag: this.data.tag,
          detail: this.data.detail,
        },
        text: {
          title: 'ADDRESSES.deleteAddress',
          cancel: 'GENERAL.cancel',
          accept: 'GENERAL.delete'
        }
      }
    }).afterClosed().subscribe(async response => {
      if (response) {
        await this.addressService.deleteAddress(this.data.id);
        if (this.currentAddressId === this.data.id) {
          if (this.isBrowser) localStorage.removeItem('address');
        }
        this.reload.emit();
        this.snackbarService.openSnackbar('ADDRESSES.delete', 'warn');
        window.location.reload();
      }
    });
  }

  public async onSetAsDefault(): Promise<void> {
    try {
      await this.addressService.setAsDefault(this.data.id);
      const addressJSON = {
        type: 'delivery',
        displayName: `${this.data.detail} ${this.data.number}`,
        store: 6
      };
      if (this.isBrowser) localStorage.setItem('address', JSON.stringify(addressJSON));
      this.favorite.emit(this.data.id);
    } catch (error) { }
  }

}
